export const formatDate = (dateString) => {
    const dateCreation = new Date(dateString);

    const jour = dateCreation.getDate().toString().padStart(2, "0");
    const mois = (dateCreation.getMonth() + 1).toString().padStart(2, "0");
    const annee = dateCreation.getFullYear();

    const heures = dateCreation.getHours().toString().padStart(2, "0");
    const minutes = dateCreation.getMinutes().toString().padStart(2, "0");
    const secondes = dateCreation.getSeconds().toString().padStart(2, "0");

    const formatPerso = `${jour}/${mois}/${annee} à ${heures}h${minutes}min${secondes}`;

    return formatPerso;
};

export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'XOF',
    }).format(amount);
};